import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import { FormattedMessage } from 'react-intl';

import 'react-datetime/css/react-datetime.css';
import moment from 'utils/moment';
import icon from '../../../icons/ic-event.svg';
import styles from '../datetime/datetime.module.scss';
import '../../component.scss';


class Date extends Component {
  constructor(props) {
    super(props);
    this.state = {
      init: false,
      currentDate: moment(moment().format()),
      firstRender: true
    };
    const { isRequired, updateFieldErrors, answer, noDefault } = this.props;
    this.focused = false;
    if (noDefault && isRequired && (answer === '' || answer === undefined || !answer)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
  }

  componentDidUpdate() {
    const { init, currentDate, renderAnswer, firstRender }= this.state;
    const { answer, noDefault, avp, adp } = this.props;
    if (!answer && currentDate && !init && !noDefault) {
      this.sendCurrentDate();
    }
    if (answer && !renderAnswer && firstRender && !avp && adp) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ renderAnswer: true, firstRender: false });
    }
  }

  durationCalculation = async (
    startDate1, endDate1, calculationFormat, timeDiff, format, field, multiFieldId, multiField, handleValueChange, handleFieldErrorChanged
  ) => {
    let startDate = startDate1;
    let endDate = endDate1;
    if (startDate && endDate && moment(startDate).isValid() && moment(endDate).isValid()) {
      let timeDifference = '';
      if (calculationFormat === 'days') {
        startDate = moment(startDate).startOf('day');
        endDate = moment(endDate).startOf('day');
      }
      if (moment(endDate).isAfter(moment(startDate)) || timeDiff > 0) {
        const diff = endDate - startDate;
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const seconds = Math.floor((diff / 1000) % 60);
        const minutes = ((diff / 1000 / 60) % 60);
        const hours = (((diff / 1000 / 60 / 60) % 24));
        if (format?.key === 'days') {
           if (multiField?.durationFieldsMultiField?.excludedDays?.length > 0) {
            const excludedDays = multiField?.durationFieldsMultiField?.excludedDays;
            let iterationDay = moment(startDate).format('YYYY-MM-DD HH:MM');
              let consideredDays = 0;
              for (let i = 0; days && endDate >= moment(iterationDay); i++) {
                let weekDays = moment(iterationDay).format('dd').toUpperCase();
                const validateDay = excludedDays.some(e => e.id === weekDays);
                if (!validateDay) {
                  consideredDays += 1;
                }
                iterationDay = moment(startDate).add(i+1, 'days').format('YYYY-MM-DD HH:MM');
              }
            timeDifference = consideredDays;
          } else {
            timeDifference = days;
          }
        } else if (format?.key === 'days_hours') {
          const totalDays = diff / (1000 * 60 * 60 * 24);
          const floorDays = Math.floor(totalDays);
          const remainingHours = Math.floor((totalDays - floorDays) * 24);
          timeDifference = (floorDays + remainingHours / 100).toFixed(2);
        } else if (format?.key === 'hours') {
          timeDifference = this.convertTime((days * 24) + hours);
        } else if (format?.key === 'minutes') {
          timeDifference = this.convertTime((days * 1440) + (Math.floor(hours) === 0 ? Math.floor(hours) : hours * 60) + minutes);
        } else if (format?.key === 'seconds') {
          timeDifference = Math.floor((days * 86400) + (Math.floor(hours) * 3600) + (Math.floor(minutes) * 60) + seconds);
        }
        if (field.settings?.isOneDayDuration && field.settings.isOneDayDuration === 1) {
          timeDifference = Number((parseFloat(timeDifference) + 1).toFixed(2));
        }
      }
      if (timeDifference !== undefined && timeDifference?.toString() !== 'NaN') {
        if (multiFieldId && startDate && endDate) {
          await handleValueChange(timeDifference, multiFieldId, multiFieldId ? 'multi_field': '', {
            multiFieldId: multiFieldId || null,
            multiFieldType: multiField?.type?.key || null
          });
        } else if (!multiFieldId) {
          await handleValueChange(timeDifference, field?.id);
        }
      }
      if (startDate > endDate || timeDifference?.toString() === 'NaN'
        || (field?.required && (timeDifference === undefined || timeDifference === null || timeDifference === ''))) {
          handleFieldErrorChanged(field?.id, true);
      } else {
        handleFieldErrorChanged(field?.id, false);
      }
    }
  }

  convertTime = (value) => {
    let hours = Math.floor(value);
    let minutes = String(Math.floor((value - hours) * 60)).padStart(2, '0');
    return parseFloat(`${hours}.${minutes}`);
  }

  sendCurrentDate = () => {
    const { fieldId, isRequired, handleValueChange, handleFieldErrorChanged, updateFieldErrors, avp } = this.props;
    const { currentDate } = this.state;
    this.setState({ init: true });
    if (!avp) {
      handleValueChange(currentDate.format(), fieldId);
    } else {
      handleValueChange(currentDate, fieldId);
    }
    let updatedErrors = [];
    if (!currentDate) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
  }

  handleDisableFutureDates = (selectedDate) => {
    const { settings, answers } = this.props;
    const validations = settings?.validations || {};
    let today = moment();
    today = moment().startOf('day');
    const customValidationDate = answers ? answers[validations?.condtional_custom_field?.fieldId] : false;
    if (customValidationDate) {
      today = moment(customValidationDate).startOf('day');
    }
    if (validations?.condition?.key === 'less_than' || (validations?.condition?.key === 'less_than_custom_date' && customValidationDate)) {
      if (validations?.conditional_days > 0) {
        const specifiedDays = Number(validations?.conditional_days);
        const conditionalDays = moment(today).subtract(specifiedDays, 'days');
        if (validations?.between_condition?.key === 'with_in') {
          return selectedDate.diff(conditionalDays) > 0 && selectedDate.diff(today) <= 0;
        }
        if (validations?.between_condition?.key === 'after') {
          return selectedDate.diff(conditionalDays) <= 0;
        }
      } else {
        const diffDays = selectedDate.diff(today, 'days');
        return diffDays <= 0;
      }
    } if (validations?.condition?.key === 'greater_than' || (validations?.condition?.key === 'greater_than_custom_date' && customValidationDate)) {
      if (validations?.conditional_days > 0) {
        const specifiedDays = Number(validations?.conditional_days);
        const conditionalDays = moment(today).add(specifiedDays, 'days');
        if (validations?.between_condition?.key === 'with_in') {
          return selectedDate.diff(conditionalDays) < 0 && selectedDate.diff(today) >= 0;
        }
        if (validations?.between_condition?.key === 'after') {
          return selectedDate.diff(conditionalDays) >= 0;
        }
      } else {
        return selectedDate.diff(today) >= 0;
      }
    }
    return true;
  }

  validateDate = (value) => {
    const { widget } = this.props;
    let check = true;
    const dateFormat = localStorage.getItem('dateFormat');
    if (value !== undefined && value !== null) {
      check = moment(value, (widget?.type === 'year' ? 'YYYY' : dateFormat), true).isValid();
    }
    return !check;
  }

  inputValue = (propssss) => {
    const { renderAnswer } = this.state;
    const { answer, widget } = this.props;
    let dateFormat = localStorage.getItem('dateFormat') || 'DD/MM/YYYY';
    if (widget?.type === 'year') {
      dateFormat = 'YYYY';
    }
    return (<input {...propssss} value={renderAnswer ? moment(answer).format(dateFormat) : propssss?.value} />);
  }

  handleDependencyFields = () => {
    const { formEntryFields, fieldId, handleValueChange, handleFieldErrorChanged } = this.props;
    if (formEntryFields?.length > 0) {
      formEntryFields.forEach((field) => {
        if (field?.type === 'number'
          && field?.settings?.form_count
          && Object.values(field?.settings?.count_map_fields || {})?.filter(f => f?.id === fieldId)?.length > 0
        ) {
          handleValueChange(undefined, field?.id);
          handleFieldErrorChanged(field?.id, true);
        }
      });
    }
  }

  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange,
      handleFieldErrorChanged,
      isRequired,
      updateFieldErrors,
      avp,
      answer,
      answers,
      allFields,
      durationAnswers,
      adp
    } = this.props;
    this.setState({ date: value });
    if (value !== '') {
      if ((typeof value) === 'string' && value?.length > answer?.length) {
        if (value?.match(/^([0-9][0-9])$/)) {
          handleValueChange(`${value}/`, fieldId);
          this.setState({ renderAnswer: true });
        } else if (value?.match(/^([0-9][0-9]\/[0-9][0-9])$/)) {
          handleValueChange(`${value}/`, fieldId);
          this.setState({ renderAnswer: true });
        } else if (value?.match(/^([0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9])$/)) {
          handleValueChange(`${value}`, fieldId);
          this.setState({ renderAnswer: true });
        } else {
          handleValueChange(value, fieldId);
          this.setState({ renderAnswer: false });
        }
      } else {
          if (value && typeof value.format === 'function') {
            handleValueChange(value.format(), fieldId);
          } else {
            handleValueChange(value, fieldId);
          }
        this.setState({ renderAnswer: false });
      }
        if (allFields && allFields.length > 0) {
          setTimeout(() => {
            let fields = [...allFields];
            let fieldAnswers = { ...durationAnswers };
            const durationFields = fields?.filter(
              (e) => {
                if (e.type === 'duration') {
                  return fields.some(
                      f => (f.id === e.duration_fields?.startDateField?.fieldId || f.id === e.duration_fields?.endDateField?.fieldId)
                      && (f.type === 'datetime' || f.type === 'time')
                  );
                }
                if (e.type === 'multi_field' && e.multiple_fields) {
                  return Object.values(e.multiple_fields).some(
                    multiField => multiField?.type?.key === 'duration'
                    && (multiField?.durationFieldsMultiField?.startDateField?.fieldId
                      || multiField?.durationFieldsMultiField?.endDateField?.fieldId)
                  );
                }
                return false;
              }
            );
            if (durationFields) {
              durationFields.forEach(async (field) => {
                if (field.type !== 'duration') {
                  let startFieldId;
                  let endFieldId;
                  let calculationFormat;
                  let format;
                  let startDate;
                  let endDate;
                  if (field.type === 'multi_field' && field.multiple_fields) {
                    const foundDurationMultiFields = Object.entries(field.multiple_fields).reduce((acc, [key, multiF]) => {
                      if (multiF?.type?.key === 'duration') {
                        acc[key] = multiF;
                      }
                      return acc;
                    }, {});
                    if ((Object.keys(foundDurationMultiFields))?.length > 0) {
                      Object.entries(foundDurationMultiFields).forEach(([key, multiF]) => {
                        startFieldId = multiF.durationFieldsMultiField?.startDateField?.fieldId;
                        endFieldId = multiF.durationFieldsMultiField?.endDateField?.fieldId;
                        calculationFormat = multiF.durationFieldsMultiField?.calculationFormat?.key;
                        format = multiF.durationFieldsMultiField?.calculationFormat;
                        startDate = fieldId === startFieldId ? moment(value) : fieldAnswers?.[startFieldId] && moment(fieldAnswers?.[startFieldId]);
                        endDate = fieldId === endFieldId ? moment(value) : fieldAnswers?.[endFieldId] && moment(fieldAnswers?.[endFieldId]);
                        const timeDiff = moment(endDate).diff(moment(startDate), 'minutes');
                        if (moment(startDate).isValid() && moment(endDate).isValid()) {
                          this.durationCalculation(
                            startDate,
                            endDate,
                            calculationFormat,
                            timeDiff,
                            format,
                            field,
                            key,
                            multiF,
                            handleValueChange,
                            handleFieldErrorChanged
                          );
                        }
                      });
                    }
                  }
                }
              });
            }
          }, 0);
        }
    } else if (value !== '' && (typeof value) !== 'string') {
      handleValueChange(value?.format(), fieldId);
      this.setState({ renderAnswer: false });
    } else {
      handleValueChange('', fieldId);
      this.setState({ renderAnswer: false });
    }
    const durationFields = allFields?.filter(
      e => e.type === 'duration' && allFields.some(
        f => (f.id === e.duration_fields?.startDateField?.fieldId || f.id === e.duration_fields?.endDateField?.fieldId)
        && f.type === 'date'
      )
    );
    if (durationFields) {
      durationFields.forEach(async (field) => {
      if (field.type !== 'multi_field') {
        const startFieldId = field?.duration_fields?.startDateField?.fieldId;
        const endFieldId = field?.duration_fields?.endDateField?.fieldId;
        const startDate = fieldId === startFieldId ? moment(value) : answers?.[startFieldId] && moment(answers?.[startFieldId]);
        const endDate = fieldId === endFieldId ? moment(value) : answers?.[endFieldId] && moment(answers?.[endFieldId]);
        const timeDiff = moment(endDate).diff(moment(startDate), 'minutes');
        if (startDate && endDate && moment(startDate).isValid() && moment(endDate).isValid()) {
          let timeDifference = '';
          if (endDate > startDate || timeDiff >= 0) {
            const diff = endDate - startDate;
            const format = field?.duration_fields?.calculationFormat;
            let days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const seconds = Math.floor((diff / 1000) % 60);
            const minutes = Math.floor((diff / 1000 / 60) % 60);
            const hours = Math.floor(((diff / 1000 / 60 / 60) % 24));
            if (format?.key === 'days') {
              if (field?.duration_fields?.excludedDays?.length > 0) {
                const excludedDays = field?.duration_fields?.excludedDays;
                let iterationDay = moment(startDate).format('YYYY-MM-DD HH:MM');
                let consideredDays = 0;
                for (let i = 0; moment(endDate).format('YYYY-MM-DD HH:MM') > moment(iterationDay).format('YYYY-MM-DD HH:MM'); i++) {
                  let weekDays = moment(iterationDay).format('dd').toUpperCase();
                  const validateDay = excludedDays.some(e => e.id === weekDays);
                  if (!validateDay) {
                    consideredDays += 1;
                  }
                  iterationDay = moment(startDate).add(i+1, 'days').format('YYYY-MM-DD HH:MM');
                }
                timeDifference = consideredDays;
              } else {
                timeDifference = days;
              }
            } else if (format?.key === 'days_hours') {
              const floorDays = Math.floor(diff / (1000 * 60 * 60 * 24));
              timeDifference = Number(floorDays);
            } else if (format?.key === 'hours') {
              timeDifference = Math.floor((days * 24) + hours);
            } else if (format?.key === 'minutes') {
              timeDifference = Math.floor((days * 1440) + (hours * 60) + minutes);
            } else if (format?.key === 'seconds') {
              timeDifference = Math.floor((days * 86400) + (hours * 3600) + (minutes * 60) + seconds);
            }
            if (field.settings?.isOneDayDuration && field.settings.isOneDayDuration === 1) {
              timeDifference = Number((parseFloat(timeDifference) + 1).toFixed(2));
            }
          }
          if (timeDifference !== undefined && timeDifference?.toString() !== 'NaN') {
            await handleValueChange(timeDifference, field?.id);
          }
          if (startDate > endDate || timeDifference?.toString() === 'NaN' || (field?.required && !timeDifference)) {
            handleFieldErrorChanged(field?.id, true);
          } else {
            handleFieldErrorChanged(field?.id, false);
          }
        }
      }
      });
    }
    let updatedErrors = [];

    if (!value) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
    } else {
      handleFieldErrorChanged(fieldId, false);
      const validDate = this.handleDisableFutureDates(moment(value));
      if (!validDate) {
        handleFieldErrorChanged(fieldId, true);
      }
    }
    if ((avp || !adp) && value && this.validateDate(moment(value))) {
      handleFieldErrorChanged(fieldId, true);
    }
    this.handleDependencyFields();
    updateFieldErrors(updatedErrors);
  }

  render() {
    const { fieldId, answer, className, customField, noDefault, disabled, avp, widget, settings, Badging, adp } = this.props;
    const { currentDate, date, renderAnswer } = this.state;
    let dateFormat = localStorage.getItem('dateFormat') || 'DD/MM/YYYY';
    const isDateValidationExists = settings?.validations?.condition?.key ?? false;
    if (widget?.type === 'year') {
      dateFormat = 'YYYY';
    }
    const getWidth =() => {
      let style='';
      if (fieldId === 'date_of_birth') {
        style='447px';
      } else if (fieldId === 'lic_issue_date' || fieldId === 'lic_exp_date' || fieldId === 'wait_report_date') {
        style='96%';
      }
      return style;
      // return fieldId === 'date_of_birth' ? '447px' : fieldId === 'lic_issue_date' ? '50%' : ''
    };
    return (
      <div style={{ width: getWidth(), position: Badging ? 'relative' : 'inherit' }}>
        {customField && (
          <img src={icon} alt=""
            className={styles.dateIcon}
            style={{ position: 'absolute',
              // marginLeft: (fieldId === 'date_of_birth' ? '416px' : '330px'),
              top: '20%',
              // left: '45%',
              right: '2%',
              // marginTop: '5px',
              zIndex: '1000' }}
          />
        )}
        {!avp && adp && (
        <Datetime
              timeFormat={false}
              dateFormat={dateFormat}
              defaultValue={answer ? moment(answer) : (!noDefault && currentDate)}
              inputProps={{ readOnly: true, disabled }}
              closeOnSelect
              onChange={e => this.handleAnswerChanged(e, fieldId)}
              id={`date-field-${fieldId}`}
              className={customField? styles.dateField : className}
              isValidDate={settings?.validations && this.handleDisableFutureDates}
          renderInput={props => this.inputValue(props)}
        />
        )}
        {(avp || !adp) && (
          <>
            <Datetime
              timeFormat={false}
              dateFormat={dateFormat}
              defaultValue={answer ? moment(answer).format(dateFormat) : (!noDefault && currentDate)}
              inputProps={{ readOnly: (widget?.type === 'year' || isDateValidationExists), disabled }}
              closeOnSelect
              onChange={e => this.handleAnswerChanged(e, fieldId)}
              id={`date-field-${fieldId}`}
              className={customField? styles.dateField : className}
              isValidDate={settings?.validations && this.handleDisableFutureDates}
              viewDate={moment(moment().format())}
              renderInput={props => <input {...props} value={renderAnswer ? answer : props?.value} />}
            />
          </>
        )}
        {date && typeof date === 'string' && (
            <small key={fieldId}>
              <FormattedMessage
                id="pulpofield.datetime.error"
                defaultMessage="Incorrect format. Please fix and try again."
              />
            </small>
          )}
        {avp && !Badging && dateFormat && answer && this.validateDate(answer) && (
          <small key={fieldId}>
            <FormattedMessage
              id="pulpofield.datetime.error"
              defaultMessage="Incorrect format. Please fix and try again."
            />
          </small>
        )}
      </div>
    );
  }
}

Date.defaultProps = {
  answer: undefined
};

Date.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired
};

export default Date;
